<!--
 * @Description: 订单管理 手工订单
 * @Author: ma.cq
 * @Date: 2019-02-18 09:19:41
 * @LastEditors: YY
 * @LastEditTime: 2023-11-09 18:07:02
 -->
<template>
  <div class="hand-order" @keyup.enter="enterSearch">
    <el-form class="table-search-bar" inline :model="handForm" ref="handForm">
      <el-form-item label="提货单号" prop="takeOrderNo">
        <el-input v-model="handForm.takeOrderNo" placeholder="请输入提货单号"></el-input>
      </el-form-item>
      <el-form-item label="商品分类" prop="proType">
        <el-select v-model="handForm.proType" placeholder="请选择">
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="协议编号" prop="protocolCode">
        <el-input v-model="handForm.protocolCode" placeholder="请输入协议编号"></el-input>
      </el-form-item>
      <el-form-item label="经营组织" prop="org">
        <el-input v-model="handForm.org" placeholder="请输入经营组织"></el-input>
      </el-form-item>
      <el-form-item label="商品名称" prop="proName">
        <el-input v-model="handForm.proName" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="商品编码" prop="proCode">
        <el-input v-model="handForm.proCode" placeholder="请输入商品编码"></el-input>
      </el-form-item>
      <el-form-item label="客户名称" prop="customName">
        <el-input v-model="handForm.customName" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item label="新增时间" prop="time">
        <el-date-picker
          v-model="handForm.time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="操作人" prop="handlePersonObj">
        <SearchSelect
          v-model="handForm.handlePersonObj"
          placeholder="请选择操作人"
          type="adminUser"
          extra-label="cartonNum"
          clearable
          ref="ownerSelect"></SearchSelect>
      </el-form-item>
      <el-form-item label="币种" prop="currencyType">
        <el-select v-model="handForm.currencyType" placeholder="请选择">
          <el-option :key="0" label="全部" :value="''"></el-option>
          <el-option :key="1" label="CNY" :value="1"></el-option>
          <el-option :key="2" label="USD" :value="2"></el-option>
          <el-option :key="3" label="EUR" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="addHand" v-permission="'0100401'">新增</el-button>
        <el-button type="primary" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeTabs" @tab-click="handOrderChange">
      <el-tab-pane v-for="item in handOrderType"
        :key="item.id"
        :label="item.label"
        :name="item.id">
      </el-tab-pane>
    </el-tabs>
    <el-table
      :data="handData"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        v-if="activeTabs === '0'"
        prop="orderMain.orderCode"
        label="订单号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.takeOrderNo"
        label="提货单号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="协议编号"
        :formatter="agreementFormat"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        v-if="activeTabs === '0'"
        prop="orderMain.oldTakeOrderNo"
        label="原提货单号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.deliverySettlementTime"
        label="发货结算时间"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        v-if="activeTabs === '1'"
        prop="orderMain.oldTakeOrderNo"
        label="原提货单号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.deptName"
        label="经营组织"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        v-if="activeTabs === '1'"
        prop="orderMain.fromAddress"
        label="发货区"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        v-else
        prop="orderMain.takeArea"
        label="发货区"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.virtualTakeArea"
        label="虚拟提货区域"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        v-if="activeTabs === '0'"
        prop="orderMain.stockOrgName"
        label="库存组织"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        v-if="activeTabs === '1'"
        prop="orderMain.toAddress"
        label="目的地"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderItem.itemName"
        label="商品名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderItem.itemCode"
        label="商品编码"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.consumerName"
        label="客户名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="销售数量"
        :key="Math.random()"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.orderItem.itemNum}}{{scope.row.orderItem.itemUnit}}
        </template>
      </el-table-column>
      <el-table-column
        label="币种"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-if="scope.row.orderItem.currencyType == '1'">CNY</span>
          <span v-else-if="scope.row.orderItem.currencyType == '2'">USD</span>
          <span v-else-if="scope.row.orderItem.currencyType == '3'">EUR</span>
          <span v-else>CNY</span>
        </template>
      </el-table-column>
      <el-table-column
        label="销售单价"
        :key="Math.random()"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.orderItem.discountedPrice}}
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="itemCount"
        label="运费"
        :show-overflow-tooltip="true">
      </el-table-column> -->
      <el-table-column
        label="销售总额"
        :key="Math.random()"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.orderMain.payAmount}}
        </template>
      </el-table-column>
      <el-table-column
        label="销售净额"
        :key="Math.random()"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.orderItem.netSales ? scope.row.orderItem.netSales: '0'}}
        </template>
      </el-table-column>
      <el-table-column
        label="商品单价"
        :key="Math.random()"
        :show-overflow-tooltip="true"
        >
         <template slot-scope="scope">
          {{scope.row.orderItem.listPrice ? scope.row.orderItem.listPrice: '0'}}
        </template>
      </el-table-column>
      <el-table-column
        label="运费单价"
        :formatter="perFreightFormat"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.belongDept"
        label="所属部门"
        :show-overflow-tooltip="true">
      </el-table-column>
      <!-- <el-table-column
        prop="orderMain.plateNum"
        label="车牌号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.phoneNum"
        label="司机手机"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.driverName"
        label="司机姓名"
        :show-overflow-tooltip="true">
      </el-table-column> -->
      <el-table-column
        prop="orderMain.salesman"
        label="业务员"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.orderTime"
        label="新增时间"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.remarks"
        label="备注"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="中试装置"
        :formatter="pilotPlantFormat"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="发货装置"
        prop="orderMain.dispatchDevice"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.businessDesc"
        label="业务说明"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.agreementRemark"
        label="协议备注"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.handlePerson"
        label="操作人"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        width="200"
        prop="syncSapStatusDetails"
        label="SAP同步状态"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        v-if="activeTabs === '1'"
        :key="Math.random()"
        label="操作"
        width="500">
        <template slot-scope="scope" v-if="scope.row.transferManualDTOS">
          <el-button v-for="item in scope.row.transferManualDTOS" @click="handlePush(scope.row, item.transferDealType)" :type="item.result ? 'success' : 'danger'" :disabled="item.result" size="small" :key="item.type">{{formatText(item.type, item.transferDealType)}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <el-row class="export-row" type="flex" justify="end">
      <el-col :span="4">
        每页
        <el-select class="width100" v-model="exportForm.size" @change="handleExportSizeChange">
          <el-option v-for="item in sizeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        条
      </el-col>
      <el-col :span="4">
        第
        <el-select class="width100" v-model="exportForm.page">
          <el-option v-for="item in pageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        页
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="handleExport">导出为CSV文件</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import TagSearchSelect from '../../../components/tagSearchSelect/index'
import SearchSelect from '../../../components/searchSelect/index'
export default {
  name: 'handOrder',
  components: { TagSearchSelect, SearchSelect },
  data () {
    return {
      handForm: {
        takeOrderNo: '',
        proType: '',
        protocolCode: '',
        org: '',
        proName: '',
        proCode: '',
        customName: '',
        time: [],
        handlePersonObj: '',
        currencyType: '' // 币种
      },
      erpArr: [
        {
          type: 1,
          result: true,
          transferDealType: 1
        },
        {
          type: 2,
          result: false,
          transferDealType: 4
        }
      ],
      exportForm: {
        size: 1000,
        page: 1
      },
      sizeOptions: [
        {
          label: '1000',
          value: 1000
        },
        {
          label: '5000',
          value: 5000
        },
        {
          label: '10000',
          value: 10000
        },
        {
          label: '20000',
          value: 20000
        }
      ],
      typeOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '自营',
          value: '1'
        },
        {
          label: '贸易',
          value: '2'
        }
      ],
      activeTabs: '0',
      handOrderType: [
        {
          id: '0',
          label: '正常手工订单'
        },
        {
          id: '1',
          label: '调拨手工订单'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      handData: state => state.handOrder.list,
      listState: state => state.handOrder.listState
    }),
    pageOptions () {
      const total = this.listState.total
      const size = this.exportForm.size
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getHandOrderList', 'exportHandOrder', 'handleButton']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 按钮文字转换
    formatText (type, transferDealType) {
      if (transferDealType === 1) {
        return '子库存转移'
      } else if (transferDealType === 2) {
        return '帐户别名接收'
      } else if (transferDealType === 3) {
        return '帐户别名发放'
      } else if (transferDealType === 4 && type === '1') {
        return '发出公司销售'
      } else if (transferDealType === 4 && type === '2') {
        return '发出公司原订单退货'
      } else if (transferDealType === 5) {
        return '接收公司采购'
      } else if (transferDealType === 6) {
        return '接收公司原订单退货'
      }
    },
    handlePush (row, transferDealType) {
      const params = {
        takeOrderId: row.orderMain.takeOrderId || '',
        transferDealType
      }
      this.handleButton(params).then((res) => {
        if (res.success) {
          this.handleSearch()
        }
      })
    },
    handleSearch () {
      const params = {
        ...this.handForm,
        pageNo: 1,
        isTransfer: this.activeTabs,
        handlePerson: this.handForm.handlePersonObj.cartonNum

      }
      this.getHandOrderList(params)
    },
    addHand () {
      this.$router.push({ name: 'addHandOrder' })
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.exportForm.page = 1
    },
    // 导出
    handleExport () {
      if (!Array.isArray(this.handData) || this.handData.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportHandOrder({ ...this.exportForm, isTransfer: this.activeTabs }).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '手工订单.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    },
    reset () {
      this.$refs['handForm'].resetFields()
      this.handleSearch()
    },
    handleSizeChange (val) {
      this.getHandOrderList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getHandOrderList({ pageNo: val })
    },
    handOrderChange () {
      this.handleSearch()
    },
    agreementFormat (row) {
      switch (row.orderMain.orderType) {
        case 1: // 零散
          return '-'
        case 2: // 协议
          return row.orderAgreements && row.orderAgreements.map(item => item.agreementCode).join('、')
        default:
          break
      }
    },
    perFreightFormat (row) {
      switch (row.orderMain.orderType) {
        case 1: // 零散
          return '-'
        case 2: // 协议
          return row.orderAgreements && row.orderAgreements.map(item => item.perFreight).join('、')
        default:
          break
      }
    },
    pilotPlantFormat (row) {
      switch (row.orderMain.pilotPlanter) {
        case 1:
          return '是'
        case 2:
          return '否'
        default:
          return ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.export-row {
  margin-top: 10px;
}
.width100{
  width: 100px;
}
</style>
